module.exports = __webpack_public_path__ + "img/404.23c2df6.png";